import { render, staticRenderFns } from "./UserHomePage.vue?vue&type=template&id=6970a2d3&"
import script from "./UserHomePage.vue?vue&type=script&lang=js&"
export * from "./UserHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports